document.addEventListener("DOMContentLoaded", function () {
  const tabWrapper = document.querySelector(".stop-fueling__compare-tab");
  if (!tabWrapper) return;

  const tabButtons = tabWrapper.querySelectorAll(".tab-btn");
  const tabContents = tabWrapper.querySelectorAll(".tab-content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetTab = button.getAttribute("data-tab");

      tabButtons.forEach((btn) => btn.classList.remove("active"));

      tabContents.forEach((content) =>
        content.classList.remove("active")
      );

      button.classList.add("active");

      const activeContent = tabWrapper.querySelector(
        `#${targetTab}`
      );
      if (activeContent) {
        activeContent.classList.add("active");
      }
    });
  });
});

$(document).ready(function () {
  $('.product-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
    centerMode: false,
    prevArrow: $('.product-slider__prev'),
    nextArrow: $('.product-slider__next'),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});

// product info popup js

document.addEventListener("DOMContentLoaded", () => {
  const infoIcons = document.querySelectorAll(".product-info-icon");
  // console.log(infoIcons,"infoIcons")
  const popup = document.getElementById("productInfoPopup");
  const closeBtn = document.getElementById("closePopup");

  // infoIcons.forEach((icon) => {
  //   icon.addEventListener("click", () => {
  //     console.log("iconclickedddd")
  //     popup.classList.add("active");
  //   });
  // });

  document.addEventListener('click', async function (e) {
    const icon = e.target.closest('.product-info-icon');
    if (!icon) return;
    e.preventDefault();
    e.stopPropagation();
    // console.log(icon.dataset,"thisdataset")
    const varimage = icon.dataset.variantImage;
    const vartitle = icon.dataset.variantTitle;
    const varid = icon.dataset.variantId;
    const lefthtml = `
      <div class="product-info__img">
            <img src="${varimage}" alt="">
      </div>
      <h2>${vartitle}</h2>
    `;
    document.querySelector("#productInfoPopup .product-info__left-content").innerHTML = lefthtml;
    const locale = detectLocale();
    let ingredientUrl = `/pages/${icon.dataset.ingredients}.json`;
    let nutritionUrl = `/pages/${icon.dataset.nutrition}.json`;
    if (locale === 'nl' || locale === 'de') {
        ingredientUrl = `/${locale}${ingredientUrl}`;
        nutritionUrl = `/${locale}${nutritionUrl}`;
    }
    // console.log("Loading nutrition & ingredients data...", ingredientUrl);
       try {
        // Fetch Ingredients
        const ingredientResponse = await fetch(ingredientUrl);
        if (!ingredientResponse.ok) throw new Error(`Ingredients fetch failed: ${ingredientResponse.status}`);
        const ingredientDatas = await ingredientResponse.json();
        const parser = new DOMParser();
        // console.log("Ingredients loaded", ingredientDatas.page.body_html);
        const ingredientDoc = parser.parseFromString(ingredientDatas.page.body_html, "text/html");
        const variantContent = ingredientDoc.querySelector(`[data-variant="${varid}"]`);
        if (variantContent) {
              const target = document.querySelector(".product-info__right-content #ingredients");
              if (target) {
                  target.innerHTML = ""; // clear previous content
                  target.appendChild(variantContent.cloneNode(true)); // clone to avoid removing from original
              }
        }
        const nutritionResponse = await fetch(nutritionUrl);
        if (!nutritionResponse.ok) throw new Error(`Ingredients fetch failed: ${nutritionResponse.status}`);
        const nutritionData = await nutritionResponse.json();
        const nutritionDoc = parser.parseFromString(nutritionData.page.body_html, "text/html");
        const nutritionContent = nutritionDoc.querySelector(`[data-variant="${varid}"]`);
        if (nutritionContent) {
              const targetNutrition = document.querySelector(".product-info__right-content #nutrition .Nutritional_tab");
              if (targetNutrition) {
                  targetNutrition.innerHTML = ""; // clear previous content
                  targetNutrition.appendChild(nutritionContent.cloneNode(true)); // clone to avoid removing from original
              }
        }

    } catch (error) {
        console.error("Error loading nutrition/ingredients data:", error);
    }
    popup.classList.add("active");
  });

  closeBtn.addEventListener("click", () => {
    popup.classList.remove("active");
  });

  popup.addEventListener("click", (e) => {
    if (e.target === popup) {
      popup.classList.remove("active");
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const tabWrapper = document.querySelector(".product-info__compare-tab");
  if (!tabWrapper) return; // prevents errors on other pages

  const tabButtons = tabWrapper.querySelectorAll(".tab-btn");
  const tabContents = tabWrapper.querySelectorAll(".tab-content");

  tabButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      tabButtons.forEach(b => b.classList.remove("active"));
      tabContents.forEach(c => c.classList.remove("active"));

      btn.classList.add("active");
      tabWrapper
        .querySelector(`#${btn.dataset.tab}`)
        .classList.add("active");
    });
  });
});

document.addEventListener("click", function (e) {
    const btn = e.target.closest(".cta_guarantee_wrapper .cta") || e.target.closest(".offer-btn button");
    if (!btn) return;
    e.preventDefault();
    const targetSection = document.getElementById("plenny-shake-product-new");
    targetSection?.scrollIntoView({ behavior: "smooth" });
});


// FAQ section drop down for landing page

document.addEventListener("DOMContentLoaded", () => {
  const faqItems = document.querySelectorAll(".faq__drop-down .faq-item");

  let activeItem = document.querySelector(".faq-item.active");

  faqItems.forEach(item => {
    const question = item.querySelector(".faq-question");
    const answer = item.querySelector(".faq-answer");

    if (item.classList.contains("active")) {
      answer.style.height = answer.scrollHeight + "px";
    }

    question.addEventListener("click", () => {
      if (item === activeItem) {
        closeItem(item);
        activeItem = null;
        return;
      }

      if (activeItem) {
        closeItem(activeItem);
      }

      openItem(item);
      activeItem = item;
    });
  });

  function openItem(item) {
    const answer = item.querySelector(".faq-answer");
    item.classList.add("active");
    answer.style.height = answer.scrollHeight + "px";
  }

  function closeItem(item) {
    const answer = item.querySelector(".faq-answer");
    answer.style.height = answer.scrollHeight + "px";
    requestAnimationFrame(() => {
      answer.style.height = "0px";
    });
    item.classList.remove("active");
  }
});